import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, extractError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPasswordPage() {
    const [sp] = useSearchParams();
    const token = sp.get("token") || "";
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Password reset. Please sign in.");
            navigate("/login");
        } catch (err) {
            toast.error(extractError(err));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 auth-grid-bg">
            <div className="w-full max-w-md brut-section p-10" data-testid="reset-card">
                <div className="label-overline mb-2">New password</div>
                <h1 className="text-3xl font-bold tracking-tight mb-8">Choose a new password</h1>
                {!token ? (
                    <div className="text-sm text-destructive">No reset token in URL. Use the link from your email.</div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5">
                        <div>
                            <Label className="label-overline">New password</Label>
                            <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-sm h-11" data-testid="reset-password-input" />
                        </div>
                        <Button type="submit" disabled={loading} className="w-full rounded-sm h-11 bg-primary hover:bg-primary/90 text-primary-foreground" data-testid="reset-submit-button">
                            {loading ? "Updating..." : "Update password"}
                        </Button>
                    </form>
                )}
                <div className="mt-8 pt-6 border-t border-border text-sm">
                    <Link to="/login" className="text-primary hover:underline">Back to sign in</Link>
                </div>
            </div>
        </div>
    );
}
